import React from "react";
import { EditorState, RichUtils, KeyBindingUtil } from "draft-js";

// find the continuous range of characters with which to associate the LINK entity:
export const linkStrategy = (contentBlock, callback, contentState) => {
  contentBlock.findEntityRanges(character => {
    const entityKey = character.getEntity();
    return (
      entityKey !== null &&
      contentState.getEntity(entityKey).getType() === "LINK"
    );
  }, callback);
};

// Link component, which renders an anchor tag with the url as identified in the entity data
export const Link = props => {
  const { contentState, entityKey } = props;
  const { url } = contentState.getEntity(entityKey).getData();
  return (
    <a
      className="link"
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      aria-label={url}
      data-test="addlinkplugin-link">
      {props.children}
    </a>
  );
};

// keyBindingFn that returns 'add-link' if characters are selected’
// utility object, KeyBindingUtil with method hasCommandModifier
const addLinkPlugin = {
  keyBindingFn(event, { getEditorState }) {
    const editorState = getEditorState();
    const selection = editorState.getSelection();
    if (selection.isCollapsed()) {
      return;
    }
    if (KeyBindingUtil.hasCommandModifier(event) && event.which === 75) {
      // eslint-disable-next-line consistent-return
      return "add-link";
    }
  },

  handleKeyCommand(command, editorState, { setEditorState }) {
    if (command !== "add-link") {
      return "not-handled";
    }
    // eslint-disable-next-line no-alert
    const link = window.prompt("Paste the link -");
    const selection = editorState.getSelection();
    if (!link) {
      setEditorState(RichUtils.toggleLink(editorState, selection, null));
      return "handled";
    }
    const content = editorState.getCurrentContent();
    const contentWithEntity = content.createEntity("LINK", "MUTABLE", {
      target: "_blank",
      url: link,
    });
    const newEditorState = EditorState.push(
      editorState,
      contentWithEntity,
      "create-entity",
    );
    const entityKey = contentWithEntity.getLastCreatedEntityKey();
    setEditorState(RichUtils.toggleLink(newEditorState, selection, entityKey));
    return "handled";
  },

  decorators: [
    {
      strategy: linkStrategy,
      component: Link,
    },
  ],
};

export default addLinkPlugin;



// WEBPACK FOOTER //
// ./src/components/RevvToolBar/plugins/addLinkPlugin.js